// extracted by mini-css-extract-plugin
module.exports = {"button":"FastDealsList_button__Zvz-e","icon":"FastDealsList_icon__tCjJp","chatButtonCell":"FastDealsList_chatButtonCell__2lOas","collapseIcon":"FastDealsList_collapseIcon__3pp1L"};